import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import Cookies from "js-cookie";

const ReverseProtectedRoute = ({ Component }) => {
  const data = Cookies.get("%8564C%27");
  const history = useHistory();

  useEffect(() => {
    if (data) {
      history.push("/");
    }
  }, [data, history]);

  return <div>{!data ? <Component /> : null}</div>;
};

export default ReverseProtectedRoute;
